import styled from 'styled-components';

const TableTagWrap = styled.div`
  margin-top: 4px;
  display: inline-block;
`;

export default TableTagWrap;
